import { dialog } from "../../../../nq-component";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import { liveQueryUseCase } from "../../../../usecases/livequery";

class OnlineApplicantFormPresenter extends BaseFormPresenter {
  constructor(view, upsertUseCase, getObjectUseCase, auditUseCase) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.auditUseCase = auditUseCase;
  }

  componentDidMount() {
    this.init();
    // this.subscribe();
    this.getObject();
  }

  // subscribe() {
  //   const query = {
  //     collection: "online_applicants",
  //     where: {},
  //     include: ["all", "users", "employees"],
  //   };

  //   const insertSubscription = liveQueryUseCase().execute(query, "afterInsert");
  //   insertSubscription.on("create", (newObject) => {
  //     const currentObject = this.object;

  //     const updatedObject = {
  //       ...currentObject,
  //       [newObject.id]: newObject,
  //     };

  //     this.object = updatedObject;

  //     console.log("insert", this.object);
  //     this.view.setState({ object: updatedObject });
  //   });

  //   const updateSubscription = liveQueryUseCase().execute(query, "afterUpdate");
  //   updateSubscription.on("update", (updatedObject) => {
  //     const recruiter = this.getRecruiter(updatedObject?.recruiter?.id);
  //     updatedObject.recruiter = recruiter;
  //     this.object = updatedObject;
  //     console.log("update", this.object);
  //     this.view.setState({ object: updatedObject });
  //   });

  //   [insertSubscription, updateSubscription].forEach((subscription) => {
  //     subscription.on("error", (error) => {
  //       console.error("Subscription Error:", error);
  //     });
  //   });
  // }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = {
        include: [
          "character_references",
          "characterReferences.character_references",
          "employment_background",
          "employmentBackground.employment_background",
          "users",
          "employees",
          "recruiter.employee",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
        console.log("object", this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async assignSubmit() {
    const collection = this.view.getCollectionName();
    const changeInfo = true;
    const getInfo = "alreadyClaimed";
    const recruiter = this.object?.recruiter?.username;
    const user = this.view.getCurrentUser();
    const id = this.object.id || this.view.getObjectId();

    if (this.object?.recruiter) {
      dialog.close();
      this.view.assignSubmit(getInfo, recruiter);
      return;
    }

    if (id) {
      this.object.recruiter = { id: user.id };
      this.object.applicant = { id: this.object.applicant.id };
      const response = await this.upsertUseCase.execute(
        collection,
        this.object
      );

      const auditObject = {
        user: { id: user?.id },
        action: "UPDATE",
        module: "Listings",
        description: "Application assigned to me",
        application_id: this.object?.id,
      };

      await this.auditUseCase.execute(auditObject);

      if (response && response.id) {
        dialog.close();
        this.view.setState({ object: this.object });
        this.view.assignSubmit(changeInfo);
      }
    }
  }
}

export default OnlineApplicantFormPresenter;
